import { get, ref } from "firebase/database";
import { auth, db } from "./api_firebase";


let _nitsCache = null;
let _nitsEnVuelo = null;

const leerNitsShallow = async () => {
  try {
    const urlBase = db?.app?.options?.databaseURL;
    if (!urlBase) return null;

    const usuario = auth.currentUser;
    if (!usuario) return null;

    const token = await usuario.getIdToken();

    const control = new AbortController();
    const corte = setTimeout(() => control.abort(), 10000);

    let respuesta;
    try {
      respuesta = await fetch(
        `${urlBase}/clientes.json?shallow=true&auth=${encodeURIComponent(token)}`,
        { signal: control.signal }
      );
    } finally {
      clearTimeout(corte);
    }

    if (!respuesta.ok) return null;

    const datos = await respuesta.json();
    if (!datos || typeof datos !== "object") return null;

    return Object.keys(datos);
  } catch {
    return null;
  }
};

const leerNitsCompleto = async () => {
  const snap = await get(ref(db, "/clientes"));
  return snap.exists() ? Object.keys(snap.val()) : [];
};

export const obtenerNits = async () => {
  if (_nitsCache) return _nitsCache;
  if (_nitsEnVuelo) return _nitsEnVuelo;

  _nitsEnVuelo = (async () => {
    try {
      const nits = (await leerNitsShallow()) ?? (await leerNitsCompleto());
      _nitsCache = nits;
      return nits;
    } catch (error) {
      console.error("No se pudo obtener el listado de NITs:", error);
      return [];
    } finally {
      _nitsEnVuelo = null;
    }
  })();

  return _nitsEnVuelo;
};

export const refrescarNits = async () => {
  _nitsCache = null;
  _nitsEnVuelo = null;
  return obtenerNits();
};

export const listadoNits = [];

export const depurando = () => localStorage.getItem("DebugLogs") === "1";

export const log = (...args) => {
  if (depurando()) console.log(...args);
};

export const CONFIG = {
  years: ["2025", "2026"],
  months: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
  tipoPase: ["PERMANENTE", "LIMITADO", "TEMPORAL"],
  tiposReservas: ["aprobados", "pendientes", "rechazados"],
  esSuper: () => localStorage.getItem("Permisos") === "SUPER",
  codigoCliente: () => localStorage.getItem("CodigoCliente"),
  correoLimpio: () => localStorage.getItem("CorreoElectronico")?.replace(/[@.]/g, ""),
  razonSocial: () => localStorage.getItem("RazonSocial")
};


export const mesesCompletos = () =>
  CONFIG.years.flatMap((year) => CONFIG.months.map((mes) => ({ year, mes })));

export const ultimosMeses = (cantidad = 2) => {
  const hoy = new Date();
  return Array.from({ length: cantidad }, (_, i) => {
    const fecha = new Date(hoy.getFullYear(), hoy.getMonth() - i, 1);
    return {
      year: String(fecha.getFullYear()),
      mes: String(fecha.getMonth() + 1).padStart(2, "0"),
    };
  });
};

export const etiquetaMeses = (meses) => {
  const ordenados = [...meses].reverse();
  const unSoloAnio = new Set(ordenados.map(({ year }) => year)).size === 1;

  const nombreMes = ({ year, mes }) =>
    new Date(Number(year), Number(mes) - 1, 1).toLocaleDateString("es-CO", {
      month: "long",
      ...(unSoloAnio ? {} : { year: "numeric" }),
    });

  const nombres = ordenados.map(nombreMes);
  if (!nombres.length) return "";

  const lista = nombres.length === 1
    ? nombres[0]
    : `${nombres.slice(0, -1).join(", ")} y ${nombres[nombres.length - 1]}`;

  return unSoloAnio ? `${lista} de ${ordenados[0].year}` : lista;
};
